import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Error from 'views/pages/maintenance/Error';

const Profile = Loadable(lazy(() => import('views/profile')));
const Deployments = Loadable(lazy(() => import('views/deployments')));
const DeploymentRequests = Loadable(lazy(() => import('views/deployment-requests')));
const Analytics = Loadable(lazy(() => import('views/analytics')));
const Trials = Loadable(lazy(() => import('views/trials')));
const TrialRequests = Loadable(lazy(() => import('views/trial-requests')));
const AccessManagement = Loadable(lazy(() => import('views/settings/access-management')));
const DigitalUnits = Loadable(lazy(() => import('views/digital-units')));
const EmailTemplates = Loadable(lazy(() => import('views/settings/email-templates')));
const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    errorElement: <Error />,
    children: [
        {
            path: '/analytics',
            element: <Analytics />
        },
        {
            path: '/deployments',
            element: <Deployments />
        },
        {
            path: '/deployment-requests',
            element: <DeploymentRequests />
        },
        {
            path: '/trials',
            element: <Trials />
        },
        {
            path: '/trial-requests',
            element: <TrialRequests />
        },
        {
            path: '/digital-units',
            element: <DigitalUnits />
        },
        {
            path: '/access-management',
            element: <AccessManagement />
        },
        {
            path: '/my-profile',
            element: <Profile />
        },
        {
            path: '/email-templates',
            element: <EmailTemplates />
        }
    ]
};

export default MainRoutes;
